var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countyProfile"},[_c('h3',[_c('span',{staticClass:"countyproject"},[_vm._v("什么是县域项目？")])]),_c('div',{},[_c('p',{staticStyle:{"line-height":"35px","font-size":"18px","text-align":"center"}},[_vm._v("2020年美菜网大力开拓发展县域生鲜市场，开启新版县域经营模式，现面向全国招募县域代理商。由县域代理商负责在当地县域的营销、配送，开展餐饮B2B及住家B2C业务，共享万亿级餐饮供应链县域市场。")])]),_c('div',{staticClass:"clear"})])
}]

export { render, staticRenderFns }